export const CREATE_WIDGET = "CREATE_WIDGET";
